<template>
	<div class="ks-list" v-if="!closed">
		<component
			:is="url ? 'a' : 'div'"
			v-for="(item, index) in items"
			:key="item.id || item.uuid"
			class="ks-list-item"
			:class="classes"
			:href="url ? url(item) : undefined"
			@click="onClick($event, item)"
		>
			<div v-if="hasLeftSlot" class="ks-list-item-left">
				<slot name="left" :item="item" :index="index"></slot>
			</div>
			<div class="ks-list-item-content">
				<div class="ks-list-item-title"> <slot :item="item" :index="index"></slot></div>
				<div class="ks-list-item-subtitle"><slot name= "subtitle" :item="item" :index="index"></slot></div>
			</div>
			<div v-if="hasRightSlot" class="ks-list-item-right">
				<slot name="right" :item="item" :index="index"></slot>
			</div>
			<div v-if="hasMenuSlot">
				<slot name="menu" :item="item" :index="index"></slot>
			</div>
		</component>
	</div>
</template>

<script>
import { popupMixin } from "@/lib/popupStack"

export default {
	mixins: [popupMixin],
	props: {
		items: {
			type: Array,
			default: () => []
		},
		twoLine: {
			type: Boolean,
			default: false
		},
		bordered: {
			type: Boolean,
			default: false
		},
		// Function (item) => url. When set, items are rendered as links (middle click / context menu opens a new tab).
		url: {
			type: Function,
			default: null
		},
		closeOnClick: {
			type: Boolean,
			default: false
		}
	},
	data () {
		return {
			closed: false
		}
	},
	watch: {
		items () {
			this.closed = false;
			this.updatePopupRegistration();
		},
		closeOnClick () {
			this.updatePopupRegistration();
		}
	},
	mounted () {
		this.updatePopupRegistration();
	},
	methods: {
		updatePopupRegistration () {
			if (this.closeOnClick && !this.closed) {
				this.registerPopup();
			} else {
				this.unregisterPopup();
			}
		},
		popupElements () {
			return [this.$el];
		},
		onPopupOutsideClick () {
			this.close();
		},
		onPopupEscape () {
			this.close();
		},
		close () {
			if (this.closed) return;
			this.closed = true;
			this.unregisterPopup();
			this.$emit("close");
		},
		onClick(event, item) {
			if (this.url) {
				// Let the browser handle modified clicks (new tab/window)
				if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || event.button !== 0) {
					return;
				}
				// Without a click listener the browser follows the link itself
				if (!this.$listeners.click) {
					return;
				}
				event.preventDefault();
			}
			this.$emit('click', item);
		}
	},
	computed: {
		classes () {
			return {
				"ks-list-item-twoline": this.hasSubTitle || this.twoLine,
				"ks-list-item-oneline": !this.hasSubTitle && !this.twoLine,
//				"elevation": this.bordered,
				"ks-list-item-border-bg": this.bordered
			}
		},
		hasLeftSlot() {
			return !!this.$scopedSlots.left;
		},
		hasRightSlot() {
			return !!this.$scopedSlots.right;
		},
		hasMenuSlot() {
			return !!this.$scopedSlots.menu;
		},
		hasSubTitle() {
			return !!this.$scopedSlots.subtitle;
		}
	}
}
</script>

<style>
.ks-list {
	width: 100%;
}
a.ks-list-item {
	color: inherit;
	text-decoration: none;
}
.ks-list-item {
	display: grid;
	grid-template-columns: max-content minmax(0, 1fr) max-content 0px;
	width: 100%;
	padding-inline: 4px;
	padding-block: 2px;
	overflow: hidden;
	margin-bottom: var(--ks-margin-1);
}
.ks-list-item-border-bg {
	border-bottom: 1px solid var(--ks-background-color-light);
	abackground-color: var(--ks-background-color-light);
}

.ks-list-item-twoline {
	height: 40px;
}
.ks-list-item-oneline {
	height: 40px;
}
.ks-list-item:hover {
	background-color: var(--ks-background-color-light);
	cursor: pointer;
}
.ks-list-item-border-bg:hover {
	background-color: var(--ks-background-color-light);
	border-radius: 6px;
}

.ks-list-item-content {
	overflow: hidden;
}

.ks-list-item-title {
	text-wrap: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
	font-size: 12px;
	color: var(--ks-font-color-primary);
}
.ks-list-item-oneline .ks-list-item-title {
	line-height: 30px;
}

.ks-list-item-subtitle {
	text-wrap: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
	font-size: 12px;
	color: var(--ks-font-color-secondary);
}
.ks-list-item-left {
	line-height: 34px;
	margin-right: var(--ks-margin-2);
	font-size: 12px;
}

.ks-list-item-right {
	line-height: 34px;
	margin-left: auto;
	font-size: 12px;
	text-wrap: nowrap;
}
</style>
